import React from 'react';
interface StarDividerProps {
  tone?: 'light' | 'dark';
  align?: 'left' | 'center';
  className?: string;
}
function Star({
  className
}: {
  className: string;
}) {
  return <svg viewBox="0 0 24 24" className={className} aria-hidden="true" data-id="element-573" data-mp="2cyme7bc61w9q">
      <path fill="currentColor" d="M12 2.5l2.9 6.1 6.6.8-4.9 4.6 1.3 6.6L12 17.3l-5.9 3.3 1.3-6.6L2.5 9.4l6.6-.8L12 2.5z" data-id="element-574" data-mp="2cwjf81t1cssv" />
    </svg>;
}
export function StarDivider({
  tone = 'dark',
  align = 'center',
  className = ''
}: StarDividerProps) {
  const starColor = tone === 'dark' ? 'text-chrome-300' : 'text-navy';
  const line = tone === 'dark' ? 'bg-chrome-300/40' : 'bg-navy/20';
  return <div className={`flex items-center gap-3 ${align === 'center' ? 'justify-center' : ''} ${className}`} aria-hidden="true" data-id="element-575" data-mp="1u00eo0wasd7x">
      <span className={`h-px w-10 ${line}`} data-id="element-576" data-mp="3odrj8lzrs6wi" />
      <Star className={`h-3 w-3 ${starColor}`} data-id="element-577" data-mp="3ocq4o7jjp2a1" />
      <Star className={`h-4 w-4 text-accent`} data-id="element-578" data-mp="3obf1a8u0hwjg" />
      <Star className={`h-3 w-3 ${starColor}`} data-id="element-579" data-mp="3jfq2i7ptgjo7" />
      <span className={`h-px w-10 ${line}`} data-id="element-580" data-mp="3jcviuiemn2vu" />
    </div>;
}
export { Star };